import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Form } from 'react-simple-form-control';
import cargoService from '../../services/CargoService';
import solicitacaoService from '../../services/SolicitacaoService';
import { aplicarMascaraCPF, aplicarMascaraTelefone } from '../../helpers/Helper';

const DadosRepresentanteConveniada = ({ form, onChangeForm, setLoading, showRepresentante, setShowRepresentante, handleResponsavelChangeSet }) => {
    const [checkCelularRepresentante, setCheckCelularRepresentante] = useState(form.tipoTelefoneComercialRepresentante.value == '1');
    const [checkFixoRepresentante, setCheckFixoRepresentante] = useState(form.tipoTelefoneComercialRepresentante.value == '2');

    const [checkCelularRepresentante2, setCheckCelularRepresentante2] = useState('1');
    const [checkFixoRepresentante2, setCheckFixoRepresentante2] = useState('2');
    const [checkCelularRepresentante3, setCheckCelularRepresentante3] = useState('1');
    const [checkFixoRepresentante3, setCheckFixoRepresentante3] = useState('2');
    const [checkCelularRepresentante4, setCheckCelularRepresentante4] = useState('1');
    const [checkFixoRepresentante4, setCheckFixoRepresentante4] = useState('2');
    const [checkCelularRepresentante5, setCheckCelularRepresentante5] = useState('1');
    const [checkFixoRepresentante5, setCheckFixoRepresentante5] = useState('2');

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setLoading(true);
        let _form = { ...form };

        const listCargo = await cargoService.OnGetListaCodigoDescricao();

        _form.listCargo.value = listCargo;

        onChangeForm(_form);
        setLoading(false);
    }

    const toggleRepresentante = idx => {
        setShowRepresentante(prev => ({ ...prev, [idx]: !prev[idx] }));
    };

    async function onClickTipoTelefoneRepresentante(event, index) {
        setLoading(true);
        let _form = { ...form };

        const tipo = event.target.value;

        // Atualiza a máscara do valor atual
        //_form[`telefoneComercialRepresentante${index}`].value = aplicarMascaraTelefone(_form.telefoneComercialAdmin.value, tipo);
        _form[`telefoneComercialRepresentante${index}`].mask = tipo === '1' ? "(99) 99999-9999" : "(99) 9999-9999";
        _form[`telefoneComercialRepresentante${index}`].maxLength = tipo === '1' ? "15" : "14"
        _form[`telefoneComercialRepresentante${index}`].value = '';

        onChangeForm(_form);

        if (index === '') {
            _form.tipoTelefoneComercialRepresentante.value = tipo;
            setCheckCelularRepresentante(tipo == '1');
            setCheckFixoRepresentante(tipo == '2');
        }

        if (index === 2) {
            _form.tipoTelefoneComercialRepresentante2.value = tipo;
            setCheckCelularRepresentante2(tipo == '1');
            setCheckFixoRepresentante2(tipo == '2');
        }

        if (index === 3) {
            _form.tipoTelefoneComercialRepresentante3.value = tipo;
            setCheckCelularRepresentante3(tipo == '1');
            setCheckFixoRepresentante3(tipo == '2');
        }

        if (index === 4) {
            _form.tipoTelefoneComercialRepresentante4.value = tipo;
            setCheckCelularRepresentante4(tipo == '1');
            setCheckFixoRepresentante4(tipo == '2');
        }

        if (index === 5) {
            _form.tipoTelefoneComercialRepresentante5.value = tipo;
            setCheckCelularRepresentante5(tipo == '1');
            setCheckFixoRepresentante5(tipo == '2');
        }

        onChangeForm(_form);
        setLoading(false);
    }

    async function handleCargoChange(event, index) {
        let _form = { ...form };
        _form[`cargoRepresentante${index}`].value = event.value;
        onChangeForm(_form);
    }

    async function handleResponsavelChange(event) {
        await handleResponsavelChangeSet(event.target.value.toUpperCase(), event.currentTarget.id)
    }

    async function handleCPFChange(event) {
        setLoading(true);

        let _form = { ...form };

        var cpfInformado = event.target.value.substr(0, 14);

        if (cpfInformado === "000.000.000-00" || cpfInformado == '' || cpfInformado == undefined || cpfInformado == null || cpfInformado == 0) {
            _form.cpfRepresentante.value = '';
            _form.nomeRepresentante.value = '';
            _form.emailRepresentante.value = '';
            _form.telefoneRepresentante.value = '';
            _form.telefoneComercialRepresentante.value = '';
            _form.idTelefoneRepresentante.value = 0;
            _form.idTelefoneComercialRepresentante.value = 0;
            _form.idPessoaRepresentante.value = 0;
            _form.habilitaDadosR1.value = false;
            onChangeForm(_form);
            setLoading(false);
        }
        if (cpfInformado !== undefined && cpfInformado !== null && cpfInformado !== "" &&
            cpfInformado !== 0 && cpfInformado !== "000.000.000-00" && cpfInformado.length === 14) {
            if (_form.cpfAdmin.value == _form.cpfRepresentante.value) {
                var cpf = cpfInformado;
                _form.cpfAdmin.value = '';
                _form.nomeAdmin.value = '';
                _form.emailAdmin.value = '';
                _form.telefoneAdmin.value = '';
                _form.telefoneComercialAdmin.value = '';
                _form.idTelefoneAdmin.value = 0;
                _form.idTelefoneComercialAdmin.value = 0;
                _form.idPessoaAdmin.value = 0;
                _form.habilitaDadosR1.value = false;
                onChangeForm(_form);
                setLoading(false);
                toast.warn("O CPF informado [" + cpf + "] foi informado no campo do cpf do Representante.");
            }
            else {
                const res = await solicitacaoService.getDadosPorCPF(cpfInformado.replace('.', '').replace('.', '').replace('/', '').replace('-', ''));
                if (res.success === true && res.data !== null && res.data !== undefined) {
                    if (res.data.user !== null) {
                        _form.nomeRepresentante.value = res.data.nome || res.data.user.nome || '';
                        _form.emailRepresentante.value = res.data.email || res.data.user.email || '';

                        if (res.data.user.cdPhoneCelular != null) {
                            _form.telefoneRepresentante.value = res.data.user.celular || '';
                            _form.idTelefoneRepresentante.value = res.data.user.cdPhoneCelular || 0;
                        } else {
                            _form.telefoneRepresentante.value = '';
                            _form.idTelefoneRepresentante.value = 0;
                            _form.telefoneRepresentante.mask = '(99) 99999-9999';
                        }
                        if (res.data.user.cdPhoneComercial != null) {
                            if (res.data.user.comercial.length == 10)
                                setCheckFixoRepresentante(true);
                            else
                                setCheckCelularRepresentante(true);

                            _form.tipoTelefoneComercialRepresentante.value = res.data.user.comercial.length == 10 ? 2 : 1;
                            _form.telefoneComercialRepresentante.value = res.data.user.comercial || '';
                            _form.idTelefoneComercialRepresentante.value = res.data.user.cdPhoneComercial || 0;
                        } else {
                            _form.tipoTelefoneComercialRepresentante.value = 0;
                            _form.telefoneComercialRepresentante.value = '';
                            _form.idTelefoneComercialRepresentante.value = 0;
                        }
                        _form.ruPessoaRepresentante.value = res.data.user.ru || 0;
                        _form.habilitaDadosR1.value = (res.data.nome != '' && res.data.nome != null && res.data.user.nome != '' && res.data.user.nome != null);

                        handleResponsavelChangeSet(_form.nomeRepresentante.value, 'nomeRepresentante');
                    }

                    if (res.data.id > 0) {
                        _form.nomeRepresentante.value = res.data.nome || '';
                        _form.emailRepresentante.value = res.data.user !== null ? res.data.user.email || res.data.email : res.data.email || '';

                        if (res.data.cdPhoneCelular != null) {
                            _form.telefoneRepresentante.value = res.data.celular || '';
                            _form.idTelefoneRepresentante.value = res.data.cdPhoneCelular || null;
                        } else {
                            _form.telefoneRepresentante.value = res.data.user !== null ? res.data.user.celular || 0 : 0;
                            _form.idTelefoneRepresentante.value = res.data.user !== null ? res.data.user.cdPhoneCelular || 0 : 0;
                        }
                        if (res.data.cdPhoneComercial != null) {
                            if (res.data.comercial.length == 10)
                                setCheckFixoRepresentante(true);
                            else
                                setCheckCelularRepresentante(true);

                            _form.tipoTelefoneComercialRepresentante.value = res.data.comercial.length == 10 ? 2 : 1;
                            _form.telefoneComercialRepresentante.value = res.data.comercial || '';
                            _form.idTelefoneComercialRepresentante.value = res.data.cdPhoneComercial || null;
                        } else {
                            _form.tipoTelefoneComercialRepresentante.value = res.data.user !== null && res.data.user.comercial != null ? res.data.user.comercial.length == 10 ? 2 : 1 : 0;
                            _form.telefoneComercialRepresentante.value = res.data.user !== null ? res.data.user.comercial || '' : '';
                            _form.idTelefoneComercialRepresentante.value = res.data.user !== null ? res.data.user.cdPhoneComercial || null : null;
                        }
                        _form.idPessoaDCRepresentante.value = res.data.idPessoaDadosCadastrais || 0;
                        _form.idPessoaRepresentante.value = res.data.id || 0;
                        _form.habilitaDadosR1.value = (res.data.nome != '' && res.data.nome != null);

                        handleResponsavelChangeSet(form.nomeRepresentante.value, 'nomeRepresentante');
                    }
                }
                else {
                    _form.nomeRepresentante.value = '';
                    _form.emailRepresentante.value = '';
                    _form.telefoneRepresentante.value = '';
                    _form.idPessoaRepresentante.value = 0;
                    _form.idTelefoneRepresentante.value = 0;
                    _form.idTelefoneComercialRepresentante.value = 0;
                    _form.telefoneComercialRepresentante.value = '';
                    _form.idPessoaDCRepresentante.value = 0;
                    _form.idPessoaRepresentante.value = 0;
                    _form.ruPessoaRepresentante.value = 0;
                    _form.habilitaDadosR1.value = false;
                }
            }

            onChangeForm(_form);
            setLoading(false);
        }
    }

    async function handleInputChange(e, index = 0) {
        const { name, value, type, checked } = e.target;
        let _form = { ...form };
        let novoValor = type === "checkbox" ? checked : value;

        if (name === `telefoneComercialRepresentante${index}`) {
            const tipo = _form[`tipoTelefoneComercialRepresentante${index}`].value;
            novoValor = aplicarMascaraTelefone(novoValor, tipo);
        }

        if (name === `telefoneRepresentante${index}`) {
            novoValor = aplicarMascaraTelefone(novoValor, 1);
        }

        if (name === `cpfRepresentante${index}`) {
            novoValor = aplicarMascaraCPF(novoValor);
        }
        _form[name].value = novoValor;
        onChangeForm(_form);
    }

    return (
        <Form formControl={form}>
            <center>
                <input className="uninter-box-home-convenioempresas-btn-enviar-formulario" type="button" onClick={() => toggleRepresentante(2)} value="Representante 2" />
                <input className="uninter-box-home-convenioempresas-btn-enviar-formulario" style={{ marginLeft: 5 }} type="button" onClick={() => toggleRepresentante(3)} value="Representante 3" />
                <input className="uninter-box-home-convenioempresas-btn-enviar-formulario" style={{ marginLeft: 5 }} type="button" onClick={() => toggleRepresentante(4)} value="Representante 4" />
                <input className="uninter-box-home-convenioempresas-btn-enviar-formulario" style={{ marginLeft: 5 }} type="button" onClick={() => toggleRepresentante(5)} value="Representante 5" />
            </center>
            <div className="card-body" hidden={form.adminRepresentante.value == 1}>
                <h3>Representante 1</h3>
                <ul className="uninterconvenioempresas uninter-passo-interno">
                    <li>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>CPF</label>
                            <input type="text" id="cpfRepresentante" name="cpfRepresentante"
                                value={form.cpfRepresentante.value}
                                onChange={(e) => handleInputChange(e, '')}
                                onBlur={handleCPFChange}
                            />
                            <span className="error" id="cpfRepresentanteError"></span>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>Nome</label>
                            <input type="text" id="nomeRepresentante" name="nomeRepresentante" disabled={form.habilitaDadosR1.value} onBlur={handleResponsavelChange} onChange={(e) => handleInputChange(e, '')} />
                            <span className="error" id="nomeRepresentanteError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>RG</label>
                            <input type="text" id="rgRepresentante" name="rgRepresentante"
                                value={form.rgRepresentante.value} onChange={handleInputChange} />
                            <span className="error" id="rgRepresentanteError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label htmlFor="ddlCargoRepresentante">Cargo</label>
                            <Select
                                onChange={(e) => handleCargoChange(e, '')}
                                isLoading={form.listCargo.value.length > 0 ? false : true}
                                options={form.listCargo.value.map((o, i) => {
                                    return { id: i, value: o.codigo, label: o.descricao };
                                })}
                                placeholder="SELECIONE"
                                id={"cargoRepresentante"}
                                name={"cargoRepresentante"}
                                defaultValue={{ label: "SELECIONE", value: 0 }}
                                value={
                                    form.cargoRepresentante.value !== null
                                        ? form.listCargo.value.find(e => e.codigo === form.cargoRepresentante.value) && {
                                            label: form.listCargo.value.find(e => e.codigo === form.cargoRepresentante.value)?.descricao,
                                            value: form.cargoRepresentante.value
                                        }
                                        : { label: "SELECIONE", value: 0 }
                                }
                            />
                            <span className="error" id="cargoRepresentanteError"></span>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                            <label>Email</label>
                            <input type="email" id="emailRepresentante" name="emailRepresentante" maxLength="250"
                                value={form.emailRepresentante.value} onChange={handleInputChange} />
                            <span className="error" id="emailRepresentanteError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 uninter-campos">
                            <label>Telefone Celular</label>
                            <input type="text" id="telefoneRepresentante" name="telefoneRepresentante" maxLength="15"
                                value={form.telefoneRepresentante.value} onChange={(e) => handleInputChange(e, '')} />
                            <span className="error" id="telefoneRepresentanteError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label">Tipo Telefone Comercial</label>
                                <li className="form-check">
                                    <input type="radio" id="CelularRepresentante" name="tipoTelefoneComercialRepresentante"
                                        checked={checkCelularRepresentante} onClick={(e) => onClickTipoTelefoneRepresentante(e, '')} value="1" />
                                    <label className="label">Celular</label>
                                    <input type="radio" id="FixoRepresentante" name="tipoTelefoneComercialRepresentante"
                                        checked={checkFixoRepresentante} onClick={(e) => onClickTipoTelefoneRepresentante(e, '')} value="2" />
                                    <label className="label">Fixo</label>
                                </li>
                            </ul>
                            <center><span className="error" id="tipoTelefoneComercialRepresentanteError"></span></center>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                            <label>Telefone Comercial</label>
                            <input type="text" id="telefoneComercialRepresentante" name="telefoneComercialRepresentante" disabled={form.tipoTelefoneComercialRepresentante.value == 0}
                                value={form.telefoneComercialRepresentante.value} onChange={(e) => handleInputChange(e, '')} />
                            <span className="error" id="telefoneComercialRepresentanteError"></span>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de nota por e-mail.">Receber nota por e-mail</label>
                                <li className="form-check">
                                    <input type="checkbox" id="recebeEmailNota" name="recebeEmailNota" value="1" checked={form.recebeEmailNota.value} onChange={handleInputChange} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de boleto por e-mail.">Receber boleto por e-mail</label>
                                <li className="form-check">
                                    <input type="checkbox" id="recebeEmailBoleto" name="recebeEmailBoleto" value="1" checked={form.recebeEmailBoleto.value} onChange={handleInputChange} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            {showRepresentante[2] && (
                <div className="card-body">
                    <h3>Representante 2</h3>
                    <ul className="uninterconvenioempresas uninter-passo-interno">
                        <li>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>CPF</label>
                                <input type="text" id="cpfRepresentante2" name="cpfRepresentante2"
                                    value={form.cpfRepresentante2.value} onChange={(e) => handleInputChange(e, 2)} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>Nome</label>
                                <input type="text" id="nomeRepresentante2" name="nomeRepresentante2" onBlur={handleResponsavelChange} onChange={(e) => handleInputChange(e, 2)} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>RG</label>
                                <input type="text" id="rgRepresentante2" name="rgRepresentante2"
                                    value={form.rgRepresentante2.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label htmlFor="ddlCargoRepresentante2">Cargo</label>
                                <Select
                                    onChange={(e) => handleCargoChange(e, 2)}
                                    isLoading={form.listCargo.value.length > 0 ? false : true}
                                    options={form.listCargo.value.map((o, i) => {
                                        return { id: i, value: o.codigo, label: o.descricao };
                                    })}
                                    placeholder="SELECIONE"
                                    id={"cargoRepresentante2"}
                                    name={"cargoRepresentante2"}
                                    defaultValue={{ label: "SELECIONE", value: 0 }}
                                    value={
                                        form.cargoRepresentante2.value !== null
                                            ? form.listCargo.value.find(e => e.codigo === form.cargoRepresentante2.value) && {
                                                label: form.listCargo.value.find(e => e.codigo === form.cargoRepresentante2.value)?.descricao,
                                                value: form.cargoRepresentante2.value
                                            }
                                            : { label: "SELECIONE", value: 0 }
                                    }
                                />
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                                <label>Email</label>
                                <input type="email" id="emailRepresentante2" name="emailRepresentante2" maxLength="250"
                                    value={form.emailRepresentante2.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 uninter-campos">
                                <label>Telefone Celular</label>
                                <input type="text" id="telefoneRepresentante2" name="telefoneRepresentante2" maxLength="15"
                                    value={form.telefoneRepresentante2.value} onChange={(e) => handleInputChange(e, 2)} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label">Tipo Telefone Comercial</label>
                                    <li className="form-check">
                                        <input type="radio" id="CelularRepresentante2" name="tipoTelefoneComercialRepresentante2"
                                            checked={checkCelularRepresentante2} onClick={(e) => onClickTipoTelefoneRepresentante(e, 2)} value="1" />
                                        <label className="label">Celular</label>

                                        <input type="radio" id="FixoRepresentante2" name="tipoTelefoneComercialRepresentante2"
                                            checked={checkFixoRepresentante2} onClick={(e) => onClickTipoTelefoneRepresentante(e, 2)} value="2" />
                                        <label className="label">Fixo</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <label>Telefone Comercial</label>
                                <input type="text" id="telefoneComercialRepresentante2" name="telefoneComercialRepresentante2" disabled={form.tipoTelefoneComercialRepresentante2.value == 0}
                                    value={form.telefoneComercialRepresentante2.value}
                                    onChange={(e) => handleInputChange(e, 2)} />
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de nota por e-mail.">Receber nota por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailNotaRepresentante2" name="recebeEmailNotaRepresentante2" value="1" checked={form.recebeEmailNotaRepresentante2.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de boleto por e-mail.">Receber boleto por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailBoletoRepresentante2" name="recebeEmailBoletoRepresentante2" value="1" checked={form.recebeEmailBoletoRepresentante2.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            )}
            {showRepresentante[3] && (
                <div className="card-body">
                    <h3>Representante 3</h3>
                    <ul className="uninterconvenioempresas uninter-passo-interno">
                        <li>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>CPF</label>
                                <input type="text" id="cpfRepresentante3" name="cpfRepresentante3"
                                    value={form.cpfRepresentante3.value} onChange={(e) => handleInputChange(e, 3)} />
                            </div>

                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>Nome</label>
                                <input type="text" id="nomeRepresentante3" name="nomeRepresentante3" onBlur={handleResponsavelChange} onChange={(e) => handleInputChange(e, 3)} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>RG</label>
                                <input type="text" id="rgRepresentante3" name="rgRepresentante3"
                                    value={form.rgRepresentante3.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label htmlFor="ddlCargoRepresentante3">Cargo</label>
                                <Select
                                    onChange={(e) => handleCargoChange(e, 3)}
                                    isLoading={form.listCargo.value.length > 0 ? false : true}
                                    options={form.listCargo.value.map((o, i) => {
                                        return { id: i, value: o.codigo, label: o.descricao };
                                    })}
                                    placeholder="SELECIONE"
                                    id={"cargoRepresentante3"}
                                    name={"cargoRepresentante3"}
                                    defaultValue={{ label: "SELECIONE", value: 0 }}
                                    value={
                                        form.cargoRepresentante3.value !== null
                                            ? form.listCargo.value.find(e => e.codigo === form.cargoRepresentante3.value) && {
                                                label: form.listCargo.value.find(e => e.codigo === form.cargoRepresentante3.value)?.descricao,
                                                value: form.cargoRepresentante3.value
                                            }
                                            : { label: "SELECIONE", value: 0 }
                                    }
                                />
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                                <label>Email</label>
                                <input type="email" id="emailRepresentante3" name="emailRepresentante3" maxLength="250"
                                    value={form.emailRepresentante3.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 uninter-campos">
                                <label>Telefone Celular</label>
                                <input type="text" id="telefoneRepresentante3" name="telefoneRepresentante3" maxLength="15"
                                    value={form.telefoneRepresentante3.value} onChange={(e) => handleInputChange(e, 3)} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label">Tipo Telefone Comercial</label>
                                    <li className="form-check">
                                        <input type="radio" id="CelularRepresentante3" name="tipoTelefoneComercialRepresentante3"
                                            checked={checkCelularRepresentante3} onClick={(e) => onClickTipoTelefoneRepresentante(e, 3)} value="1" />
                                        <label className="label">Celular</label>

                                        <input type="radio" id="FixoRepresentante3" name="tipoTelefoneComercialRepresentante3"
                                            checked={checkFixoRepresentante3} onClick={(e) => onClickTipoTelefoneRepresentante(e, 3)} value="2" />
                                        <label className="label">Fixo</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <label>Telefone Comercial</label>
                                <input type="text" id="telefoneComercialRepresentante3" name="telefoneComercialRepresentante3" disabled={form.tipoTelefoneComercialRepresentante3.value == 0}
                                    value={form.telefoneComercialRepresentante3.value}
                                    onChange={(e) => handleInputChange(e, 3)} />
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de nota por e-mail.">Receber nota por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailNotaRepresentante3" name="recebeEmailNotaRepresentante3" value="1"
                                            checked={form.recebeEmailNotaRepresentante3.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de boleto por e-mail.">Receber boleto por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailBoletoRepresentante3" name="recebeEmailBoletoRepresentante3" value="1"
                                            checked={form.recebeEmailBoletoRepresentante3.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            )}
            {showRepresentante[4] && (
                <div className="card-body">
                    <h3>Representante 4</h3>
                    <ul className="uninterconvenioempresas uninter-passo-interno">
                        <li>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>CPF</label>
                                <input type="text" id="cpfRepresentante4" name="cpfRepresentante4"
                                    value={form.cpfRepresentante4.value} onChange={(e) => handleInputChange(e, 4)} />
                            </div>

                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>Nome</label>
                                <input type="text" id="nomeRepresentante4" name="nomeRepresentante4" onBlur={handleResponsavelChange} onChange={(e) => handleInputChange(e, 4)} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>RG</label>
                                <input type="text" id="rgRepresentante4" name="rgRepresentante4"
                                    value={form.rgRepresentante4.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label htmlFor="ddlCargoRepresentante4">Cargo</label>
                                <Select
                                    onChange={(e) => handleCargoChange(e, 4)}
                                    isLoading={form.listCargo.value.length > 0 ? false : true}
                                    options={form.listCargo.value.map((o, i) => {
                                        return { id: i, value: o.codigo, label: o.descricao };
                                    })}
                                    placeholder="SELECIONE"
                                    id={"cargoRepresentante4"}
                                    name={"cargoRepresentante4"}
                                    defaultValue={{ label: "SELECIONE", value: 0 }}
                                    value={
                                        form.cargoRepresentante4.value !== null
                                            ? form.listCargo.value.find(e => e.codigo === form.cargoRepresentante4.value) && {
                                                label: form.listCargo.value.find(e => e.codigo === form.cargoRepresentante4.value)?.descricao,
                                                value: form.cargoRepresentante4.value
                                            }
                                            : { label: "SELECIONE", value: 0 }
                                    }
                                />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                                <label>Email</label>
                                <input type="email" id="emailRepresentante4" name="emailRepresentante4" maxLength="250"
                                    value={form.emailRepresentante4.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 uninter-campos">
                                <label>Telefone Celular</label>
                                <input type="text" id="telefoneRepresentante4" name="telefoneRepresentante4" maxLength="15"
                                    value={form.telefoneRepresentante4.value} onChange={(e) => handleInputChange(e, 4)} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label">Tipo Telefone Comercial</label>
                                    <li className="form-check">
                                        <input type="radio" id="CelularRepresentante4" checked={checkCelularRepresentante4}
                                            onClick={(e) => onClickTipoTelefoneRepresentante(e, 4)} name="tipoTelefoneComercialRepresentante4" value="1" />
                                        <label className="label">Celular</label>

                                        <input type="radio" id="FixoRepresentante4" checked={checkFixoRepresentante4}
                                            onClick={(e) => onClickTipoTelefoneRepresentante(e, 4)} name="tipoTelefoneComercialRepresentante4" value="2" />
                                        <label className="label">Fixo</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <label>Telefone Comercial</label>
                                <input type="text" id="telefoneComercialRepresentante4" name="telefoneComercialRepresentante4" disabled={form.tipoTelefoneComercialRepresentante4.value == 0}
                                    value={form.telefoneComercialRepresentante4.value}
                                    onChange={(e) => handleInputChange(e, 4)} />
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de nota por e-mail.">Receber nota por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailNotaRepresentante4" name="recebeEmailNotaRepresentante4" value="1"
                                            checked={form.recebeEmailNotaRepresentante4.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de boleto por e-mail.">Receber boleto por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailBoletoRepresentante4" name="recebeEmailBoletoRepresentante4" value="1"
                                            checked={form.recebeEmailBoletoRepresentante4.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            )}
            {showRepresentante[5] && (
                <div className="card-body">
                    <h3>Representante 5</h3>
                    <ul className="uninterconvenioempresas uninter-passo-interno">
                        <li>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>CPF</label>
                                <input type="text" id="cpfRepresentante5" name="cpfRepresentante5"
                                    value={form.cpfRepresentante5.value} onChange={(e) => handleInputChange(e, 5)} />
                            </div>

                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>Nome</label>
                                <input type="text" id="nomeRepresentante5" name="nomeRepresentante5" onBlur={handleResponsavelChange} onChange={(e) => handleInputChange(e, 5)} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>RG</label>
                                <input type="text" id="rgRepresentante5" name="rgRepresentante5"
                                    value={form.rgRepresentante5.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label htmlFor="ddlCargoRepresentante5">Cargo</label>
                                <Select
                                    onChange={(e) => handleCargoChange(e, 5)}
                                    isLoading={form.listCargo.value.length > 0 ? false : true}
                                    options={form.listCargo.value.map((o, i) => {
                                        return { id: i, value: o.codigo, label: o.descricao };
                                    })}
                                    placeholder="SELECIONE"
                                    id={"cargoRepresentante5"}
                                    name={"cargoRepresentante5"}
                                    defaultValue={{ label: "SELECIONE", value: 0 }}
                                    value={
                                        form.cargoRepresentante5.value !== null
                                            ? form.listCargo.value.find(e => e.codigo === form.cargoRepresentante5.value) && {
                                                label: form.listCargo.value.find(e => e.codigo === form.cargoRepresentante5.value)?.descricao,
                                                value: form.cargoRepresentante5.value
                                            }
                                            : { label: "SELECIONE", value: 0 }
                                    }
                                />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                                <label>Email</label>
                                <input type="email" id="emailRepresentante5" name="emailRepresentante5" maxLength="250"
                                    value={form.emailRepresentante5.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 uninter-campos">
                                <label>Telefone Celular</label>
                                <input type="text" id="telefoneRepresentante5" name="telefoneRepresentante5" maxLength="15"
                                    value={form.telefoneComercialRepresentante5.value} onChange={(e) => handleInputChange(e, 5)} />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label">Tipo Telefone Comercial</label>
                                    <li className="form-check">
                                        <input type="radio" id="CelularRepresentante5" checked={checkCelularRepresentante5}
                                            onClick={(e) => onClickTipoTelefoneRepresentante(e, 5)} name="tipoTelefoneComercialRepresentante5" value="1" />
                                        <label className="label">Celular</label>

                                        <input type="radio" id="FixoRepresentante5" checked={checkFixoRepresentante5}
                                            onClick={(e) => onClickTipoTelefoneRepresentante(e, 5)} name="tipoTelefoneComercialRepresentante5" value="2" />
                                        <label className="label">Fixo</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 uninter-campos">
                                <label>Telefone Comercial</label>
                                <input type="text" id="telefoneComercialRepresentante5" name="telefoneComercialRepresentante5" maxLength="15"
                                    value={form.telefoneComercialRepresentante5.value} onChange={handleInputChange} />
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de nota por e-mail.">Receber nota por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailNotaRepresentante5" name="recebeEmailNotaRepresentante5" value="1"
                                            checked={form.recebeEmailNotaRepresentante5.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 uninter-campos uninter-campos" hidden={form.tipoConvenio.value == 1 || form.tipoConvenio.value == 0}>
                                <ul className="uninter-declaro-convenioempresas">
                                    <label className="label" tooltip-position="bottom" tooltip="Selecionar quando for necessário envio de boleto por e-mail.">Receber boleto por e-mail</label>
                                    <li className="form-check">
                                        <input type="checkbox" id="recebeEmailBoletoRepresentante5" name="recebeEmailBoletoRepresentante5" value="1"
                                            checked={form.recebeEmailBoletoRepresentante5.value} onChange={handleInputChange} />
                                        <label className="label">Sim</label>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            )}
        </Form>
    );
}

export default DadosRepresentanteConveniada;